import { render, staticRenderFns } from "./MedicinesPhaseV2.vue?vue&type=template&id=b4559920&scoped=true&"
import script from "./MedicinesPhaseV2.vue?vue&type=script&lang=js&"
export * from "./MedicinesPhaseV2.vue?vue&type=script&lang=js&"
import style0 from "./MedicinesPhaseV2.vue?vue&type=style&index=0&id=b4559920&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4559920",
  null
  
)

export default component.exports